// app/components/approval/ApprovalActionButtons.tsx

import { t } from "i18next";

interface ApprovalActionButtonsProps {
  transId: number;
  onReject?: (transId: number) => void;
  onApprove?: (transId: number) => void;
  disabled?: boolean;
}

const ApprovalActionButtons = ({
  transId,
  onReject,
  onApprove,
  disabled = false,
}: ApprovalActionButtonsProps) => {

  const handleClick =
    (handler?: (transId: number) => void) =>
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      handler?.(transId);
    };

  return (
    <div className="gx-approval-actions">
      <button
        type="button"
        className="gx-approval-actions__reject gx-p14-md"
        disabled={disabled}
        onClick={handleClick(onReject)}
      >
        {t("reject")}
      </button>
      <button
        type="button"
        className="gx-approval-actions__approve gx-p14-md"
        disabled={disabled}
        onClick={handleClick(onApprove)}
      >
        {t("approve")}
      </button>
       
    </div>
  );
};

export default ApprovalActionButtons;
